/* eslint-disable max-len */
var UI_SORT_DESCENDING = {
  "default": 'M13.86,11.87a1,1,0,0,1-.07,1.42,1,1,0,0,1-1.43-.07L8.07,8.43v17.8a1,1,0,0,1-2,0V8.43L1.76,13.22h0a1,1,0,0,1-1.5-1.35L6.31,5.13l0,0a1.24,1.24,0,0,1,.23-.17s.06-.05.1-.06a.93.93,0,0,1,.8,0s.06,0,.1.06a1.24,1.24,0,0,1,.23.17l0,0Zm4-5.09h1.51a1,1,0,1,0,0-2H17.88a1,1,0,1,0,0,2Zm0,5.11h4a1,1,0,0,0,0-2h-4a1,1,0,1,0,0,2Zm0,5.11h7.06a1,1,0,0,0,0-2H17.88a1,1,0,1,0,0,2Zm0,5.1H28a1,1,0,0,0,0-2H17.88a1,1,0,1,0,0,2ZM31,25.19H17.88a1,1,0,1,0,0,2H31a1,1,0,1,0,0-2Z',
  globetrotter: 'M2.5 7.5L7.5 2.5M7.5 2.5L12.5 7.5M7.5 2.5V29.5M17.5 4.5H14.5M20.5 10.25H14.5M23.5 16H14.5M26.5 21.75H14.5M29.5 27.5H14.5'
};

export { UI_SORT_DESCENDING };
//# sourceMappingURL=UI_SORT_DESCENDING.js.map
